import { instructionStrings } from '@data/instruction';
import { z } from 'zod';

export const InstructionStatusName = z.enum(['送信済', '未送信', '修正依頼済', '確認済み']);

export type InstructionStatusName = z.infer<typeof InstructionStatusName>;

export const InstructionClientStatusName = z.enum([
  '未送信',
  '送信済',
  '修正してください',
  '確認済み',
]);

export type InstructionClientStatusName = z.infer<typeof InstructionClientStatusName>;

export const InstructionStatus = z.object({
  name: InstructionStatusName,
  time: z.string(),
  message: z.string().nullish(),
  is_visible: z.boolean(),
});

export type InstructionStatus = z.infer<typeof InstructionStatus>;

export const InstructionType = z.enum(['customsInstruction', 'deliveryInstruction']);

export type InstructionType = z.infer<typeof InstructionType>;

export const InstructionChangeRequiredForm = z.object({
  message: z.string().label(instructionStrings.requestChangesReason),
});

export type InstructionChangeRequiredForm = z.infer<typeof InstructionChangeRequiredForm>;
